const UNIX_EPOCH = new Date('1 January 1970 00:00:00 UTC')
const UTC_OFFSET = UNIX_EPOCH.getTimezoneOffset()

const { consts } = require('../consts')

/**
 * Időzóna alapján a különbség ms-ben.
 * @param {Date} date - A dátum, ami alapján a timeZoneOffset-et nézzük.
 * @returns {number} A különbség ms.
 */
module.exports.getTimezoneOffsetDiffInMs = function getTimezoneOffsetDiffInMs (date = new Date()) {
  const localOffset = date.getTimezoneOffset()

  return (UTC_OFFSET - localOffset) * consts.MINUTE_IN_MS
}
